// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"814298ec","167":"685dcb66","668":"a365224a","787":"86e442ec"}[chunkId] + ".chunk.js";
};